import { Box, Grid, Heading } from '@chakra-ui/react';
import { FC, ReactNode } from 'react';

type Props = {
  heading: string;
  children: ReactNode;
};

const StepBox: FC<Props> = ({ heading, children }) => {
  return (
    <Box p={10} mb={8} borderRadius='xl' borderWidth='1px'>
      <Heading size='md' mb={6}>
        {heading}
      </Heading>
      <Grid
        templateColumns={[
          'repeat(1, minmax(0, 1fr))',
          'repeat(2, minmax(0, 1fr))',
          'repeat(3, minmax(0, 1fr))',
          'repeat(4, minmax(0, 1fr))'
        ]}
        gap={6}
      >
        {children}
      </Grid>
    </Box>
  );
};

export default StepBox;
